/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsAlphabetCollection,
    SharedserviceMelcoModelsAlphabetCollectionFromJSON,
    SharedserviceMelcoModelsAlphabetCollectionFromJSONTyped,
    SharedserviceMelcoModelsAlphabetCollectionToJSON,
    SharedserviceMelcoModelsCustomWarning,
    SharedserviceMelcoModelsCustomWarningFromJSON,
    SharedserviceMelcoModelsCustomWarningFromJSONTyped,
    SharedserviceMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollection
 */
export interface SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollection {
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsAlphabetCollection>}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollection
     */
    list: Array<SharedserviceMelcoModelsAlphabetCollection>;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsCustomWarning>}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollection
     */
    warning_list?: Array<SharedserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollection
     */
    total: number;
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollectionFromJSON(json: any): SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollection {
    return SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollectionFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(SharedserviceMelcoModelsAlphabetCollectionFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(SharedserviceMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollectionToJSON(value?: SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(SharedserviceMelcoModelsAlphabetCollectionToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(SharedserviceMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


